"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderCell = function HeaderCell(_ref) {
  var width = _ref.width,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      otherProps = _objectWithoutProperties(_ref, ["width", "className", "children", "title"]);

  return /*#__PURE__*/_react.default.createElement(Th, _extends({
    width: width,
    title: title,
    className: className
  }, otherProps), children);
};

var Th = _styledComponents.default.th.withConfig({
  displayName: "Th"
})(["padding-bottom:1.3rem;width:", ";font-weight:", ";font-size:", ";color:", ";vertical-align:middle;"], function (props) {
  return props.width;
}, function (props) {
  return props.title ? "700" : "400";
}, function (props) {
  return props.title ? "1.6rem" : "1.4rem";
}, function (props) {
  return props.title ? "#5b5550" : "#a29c95";
});

HeaderCell.defaultProps = {
  otherProps: {},
  title: false,
  width: 'unset'
};
HeaderCell.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node,

  /** The width of the tableCell element */
  width: _propTypes.string,

  /** Applies title styling to the cell */
  title: _propTypes.bool
};
var _default = HeaderCell;
exports.default = _default;